module.exports = __webpack_public_path__ + "res/media/profile_img_female01.94b3df28.png";